<template>
  <div class="sunshine-port">
    <Crumbs :info='info' :title='navList[0]'/>
    <div class="customs-container">
      <div class="port-nav">
        <menu-com :navList='navList'></menu-com>
      </div>
      <div class="port-content">
        <!-- 书写内容区域 -->
        <ul
          class="customs-list"
          v-for="(item, noticeId) in newslist"
          :key="noticeId"
        >
          <div class="customsLeft">
            <div>{{ noticeId + 1 }}</div>
          </div>
          <div class="titleCon">
            <li @click="goDetail(item.noticeId, item.noticeTitle)">
              {{ item.noticeTitle }}
            </li>
            <div>{{ changeSub(item.updateTime||item.createTime) }}</div>
          </div>
        </ul>
        <div class="iojs">
          <i class="el-icon-d-arrow-left"></i>
          <ul v-for="(sa) in pagetotal">
            <li @click="getpage(sa)">
              {{sa}}
            </li>
          </ul>
          <i class="el-icon-d-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuCom from "./common/menuCom.vue"
import Crumbs from "./common/Crumbs.vue"
import {navList} from "../../../model/policies"
import axios from "axios";
import Customs from "./Detail/Customs";
export default {
  components:{
    menuCom,Crumbs,Customs
  },
  data () {
    return {
      info:{},
      navList,
      newslist: [],
      total: "",
      page: 1
    }
  },
  computed: {
    pagetotal() {

      return Math.ceil(this.total/6);
    }},
  methods: {

    goDetail(id, title) {
      this.$router.push({
        path: `/policies/customs/${id}`,
        query:{title,flag:3}
      })
    },
    getpage(i) {
      this.page=i || this.page;
      axios({
        method: 'GET',
        url: `http://121.40.212.122:8091/system/notice/list1?pageNum=${this.page}&pageSize=6&noticeType=3`
      }).then(response => {
        console.log(response);
        this.newslist = response.data.rows;
        this.total = response.data.total;
      })
    },
    changeSub(str){
      if (str) {
        return str.substring(0,10)
      }
    }
  },
  created(){
    this.getpage();
    const path=this.$route.fullPath;
    const index=navList.findIndex(item=>item.path===path);
    if(index!==-1){
      this.info=navList[index];
    }
  }
};
</script>

<style scoped>
.customs-container {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  display: flex;
  padding: 34px 30px;
  border: 1px solid #d3d3d3;
  margin-top: 30px;
  margin-bottom: 186px;
  flex-direction: column;
}
.port-content {
  flex:1;
}
.port-nav {
  margin-bottom: 20px;
}
.port-content h2 {
  height: 38px;
  font-size: 30px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #34373b;
  line-height: 38px;
  display: block;
  margin-bottom: 34px;
}
.port-content p {
  text-indent: 2em;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
  line-height: 34px;
  margin-bottom: 34px;
}

.customs-list {
  font-size: 22px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  color: #585d66;
  line-height: 38px;
  display: flex;
  border: #ccc solid 1px;
  border-radius: 15px;
  padding: 10px;
  margin-bottom: 20px;
}
.customsLeft {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px 10px 0;
}
.customsLeft div {
  width: 42px;
  height: 56px;
  font-size: 30px;
  text-align: center;
  line-height: 52px;
  font-weight: bold;
  color: #fff;
  background-image: url("../../../assets/titleNum.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.titleCon {
  width: calc(100% - 62px);
}
.titleCon div {
  text-align: right;
}
.customs-container li {
  /* margin-bottom: 24px; */
  cursor: pointer;
}
.customs-container li:hover{
  color: #3682ed;
}
.port-content>div{
  font-size: 22px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #33363b;
  line-height: 38px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.port-content>div i {
  margin-left: 4px;
}
.port-content>div:hover{
  color: #3682ed;

}
.iojs li{
  /* height: 20px; */
  width: 50px;
  margin-left:50%;
}
.iojs{
  margin-left:24%;
}
</style>



// WEBPACK FOOTER //
// src/components/children/Policies/Outer.vue